import { windowIsExist } from ".";

const LocalStorageUtils = {
  setItem: (key: string, value: any) => {
    if (!windowIsExist) return;
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error setting item in localStorage: ${error}`);
    }
  },

  getItem: (key: string) => {
    if (!windowIsExist) return;
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error getting item from localStorage: ${error}`);
      return null;
    }
  },

  removeItem: (key: string) => {
    if (!windowIsExist) return;
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing item from localStorage: ${error}`);
    }
  },

  clear: () => {
    if (!windowIsExist) return;
    try {
      localStorage.clear();
    } catch (error) {
      console.error(`Error clearing localStorage: ${error}`);
    }
  },
};

export default LocalStorageUtils;
